import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import moment from 'moment';

import Loader from '../../leftpanel/loader';
import Modal from '../modal';

import FSCReport from '../../report/report';
import { IReportProps } from '../../../types/report';

import './report-modal.scss';
import { IPerformAuditCriteriaData } from '../../../types/auditdata';

import ga, { GACategories, GAActions } from '../../../utils/googleAnalytics.utils';
import mapController from '../../../controllers/MapController';

const ReportModal = ({
  setReportReady,
  performAuditLayers,
  auditAreaCoordinates,
  auditArea,
  visibleLayers,
  auditTreeLoss,
  map,
  charts,
  reportReady,
  closeModal,
}: IReportProps) => {
  const date = moment().format('DD/MM/YYYY');

  const performAuditMap: Map<string, IPerformAuditCriteriaData> = new Map();
  performAuditLayers.forEach((pal) => {
    if (!performAuditMap.has(pal.criteriaNumber)) {
      performAuditMap.set(pal.criteriaNumber, pal);
    }
  });

  const pdfDoc = (
    <FSCReport
      map={map}
      mapScale={mapController.getMapScale()}
      charts={charts}
      date={date}
      auditAreaCoordinates={auditAreaCoordinates}
      auditAreaSize={auditArea.size}
      performAuditMap={performAuditMap}
      visibleLayers={visibleLayers}
      auditTreeLoss={auditTreeLoss}
    />
  );

  const exitReport = () => {
    closeModal(false);
    setReportReady(false);
  };

  return (
    <Modal>
      <div className='report-modal'>
        <button className='close esri-icon-close' onClick={exitReport} />
        <div className='report-modal__body'>
          <p className='report-modal__info'>Download and save your report as a PDF</p>
          {reportReady ? (
            // ! only works on the first download. You have to refresh the page to download another
            // ! seems to have to do with loading provided by React PDF
            <PDFDownloadLink document={pdfDoc} fileName={`GIS Portal Report - ${new Date().toTimeString()}.pdf`}>
              {({ blob, url, loading, error }) => {
                if (error) {
                  console.log('ERROR', error);
                }
                return (
                  <React.Fragment>
                    {loading && <Loader />}
                    <button className='report-modal__button' onClick={() => {
                      ga.event(GACategories.DownloadButton, GAActions.Clicked, "Report");
                    }}>Download</button>
                  </React.Fragment>
                );
              }}
            </PDFDownloadLink>
          ) : (
            // HELPFUL TO LEAVE THIS HERE UNTIL WE'RE DONE WITH STYLING AS IT'S QUICKER TO SEE CHANGES RATHER THAN WAITING TO DOWNLOAD
            // ! loads the whole application in the PDF viewer window...
            // <PDFViewer width={800} height={800}>
            //     <FSCReport
            //       map={map}
            //       charts={charts}
            //       date={date}
            //       auditAreaCoordinates={auditAreaCoordinates}
            //       auditAreaSize={auditArea.size}
            //       performAuditMap={performAuditMap}
            //       visibleLayers={visibleLayers}
            //       auditTreeLoss={auditTreeLoss}
            //     />
            // </PDFViewer>
            <React.Fragment>
              <Loader />
              <p>Loading...</p>
            </React.Fragment>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ReportModal;
